import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { PostSetRowProps } from '../SetRowTypes'
import SetResult from '../../HelperClass/Result'
import LabelFont from '../../../../Theme/Fonts/Label'
import { fallbackPeriods } from '../Live'
import SetRowTemplate from '../Template'

const PostSetRow: FunctionComponent<PostSetRowProps> = ({
    homeCompetitor,
    awayCompetitor,
    caption,
    onPressMatch,
    homeScore,
    awayScore,
    periods,
    winner,
    hideImage,
    additionalField,
    additionalFieldOffset,
    hidePeriods = !periods || periods.length > 5,
    paddingTop,
    borderRadius,
    noExpand,
}) => {
    const periodsWithFallback = periods && periods.length ? periods : fallbackPeriods
    return (
        <SetRowTemplate
            homeCompetitor={homeCompetitor}
            awayCompetitor={awayCompetitor}
            hideImage={hideImage}
            onPressMatch={onPressMatch}
            winner={winner}
            additionalField={additionalField}
            additionalFieldOffset={additionalFieldOffset}
            paddingTop={paddingTop}
            borderRadius={borderRadius}
            noExpand={noExpand}
        >
            <Grid horizontal noExpand width={120}>
                {homeScore !== undefined && awayScore !== undefined ? (
                    <SetResult type="OVERALL" homeScore={homeScore} awayScore={awayScore} />
                ) : null}
                {periods && !hidePeriods ? (
                    <Grid horizontal>
                        {periodsWithFallback.map((item, index) => (
                            <SetResult
                                key={`set-result-${homeCompetitor}-${awayCompetitor}-${index}-${item.homeScore}-${item.awayScore}`}
                                type="DEFAULT"
                                homeScore={item.homeScore}
                                awayScore={item.awayScore}
                            />
                        ))}
                    </Grid>
                ) : null}
                {hidePeriods && caption ? (
                    <Grid center>
                        <LabelFont>{caption}</LabelFont>
                    </Grid>
                ) : null}
            </Grid>
        </SetRowTemplate>
    )
}

export default PostSetRow
